export default __webpack_public_path__ + "static/media/barcode-white.b0b1a992.svg";